// extracted by mini-css-extract-plugin
export default {"content":"Content_content__rs-s9"};